import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, control, radius } = theme.tokens;

  return {
    root: {
      borderRadius: radius.pill,
      whiteSpace: "nowrap",
      textDecoration: "none"
    },
    primary: {},
    secondary: {
      backgroundColor: color.field,
      color: color.ink,
      "&:hover": { backgroundColor: color.fieldHover }
    },
    outline: {
      color: color.ink
    },
    ghost: {
      color: color.ink
    },
    destructive: {
      backgroundColor: color.danger,
      color: color.bg,
      "&:hover": { backgroundColor: color.dangerHover }
    },
    lg: { minHeight: control.lg },
    md: { minHeight: control.md },
    sm: { minHeight: control.sm },
    iconOnly: {
      minWidth: control.icon,
      width: control.icon,
      minHeight: control.icon,
      height: control.icon,
      padding: 0
    },
    icon: {
      display: "inline-flex",
      marginRight: 8,
      "& svg": { fontSize: theme.tokens.iconSize.md },
      "$iconOnly &": { marginRight: 0 }
    },
    withPrice: {
      justifyContent: "space-between",
      "& .MuiButton-label": {
        justifyContent: "space-between",
        gap: 16
      }
    },
    price: {
      fontWeight: 800,
      marginLeft: 16
    }
  };
});

export default withCustomStyles;
